import { useEffect, useState } from 'react';

// Live 1s tick. `visible` gates the interval so it only runs while the
// consumer actually needs a live clock (a modal that's open, an
// unfinished workout's elapsed-time counter, ...) — a single shared
// primitive so every "tick every second while X" surface uses the SAME
// setInterval/cleanup instead of re-rolling it per callsite (CN-11).
// Moved here from apps/mobile/src/logger/useNowTick.ts, which was deleted
// (no re-export shim: both consumers import from @jackedlogs/ui).
// Originally extracted verbatim out of LoggerScreen body (Track R); kept
// bit-identical through the move.
export function useNowTick(visible: boolean): number {
  const [nowMs, setNowMs] = useState(() => Date.now());
  useEffect(() => {
    if (!visible) return undefined;
    const id = setInterval(() => setNowMs(Date.now()), 1000);
    return () => clearInterval(id);
  }, [visible]);
  return nowMs;
}
